import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component

import history from 'utils/history';

//components
import NoAbsence from 'components/Absences/NoAbsence';
import CustomTableV2 from 'components/CustomTableV2';

function TableAbsence({
  dataSource,
  dataColumns,
  emptyTitle,
  emptyContent,
  activeTab,
  createAbsenceAction,
  openFinishedAbsence,
  allSelectedItemUpd,
  // default props
  className,
  ...rest
}) {
  const mainClassNames = classNames('table-absence-wrapper', className);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      allSelectedItemUpd(selectedRows, selected);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      allSelectedItemUpd(selectedRows, selected);
    },
  };

  return (
    <div className={mainClassNames}>
      {dataSource.length > 0 ? (
        <CustomTableV2
          columns={dataColumns}
          dataSource={dataSource}
          pagination={{ pageSize: 50 }}
          rowKey={record => record._id}
          rowSelection={activeTab !== 'finished' ? { ...rowSelection } : null}
          scroll={{ y: '55vh' }}
          onRow={(record, index) => {
            return {
              onClick: () => history.push(`/absences/${record?._id}`),
            };
          }}
          locale={{
            emptyText: (
              <NoAbsence
                title={emptyTitle}
                content={emptyContent}
                newAction={createAbsenceAction}
                filterAction={openFinishedAbsence}
              />
            ),
          }}
        />
      ) : (
        <NoAbsence
          title={emptyTitle}
          content={emptyContent}
          newAction={createAbsenceAction}
          filterAction={openFinishedAbsence}
        />
      )}
    </div>
  );
}

TableAbsence.defaultProps = {
  emptyTitle: 'Aucune absence à traiter',
  emptyContent: 'Vous avez traité toutes les absences',
};
TableAbsence.propTypes = {
  dataColumns: PropTypes.array,
  dataSource: PropTypes.array,
  activeTab: PropTypes.string,
  emptyTitle: PropTypes.string,
  emptyContent: PropTypes.string,
  createAbsenceAction: PropTypes.func,
  openFinishedAbsence: PropTypes.func,
};

export default memo(TableAbsence);
